
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 4.66602V8.66602H10","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2 11.334C2 9.74269 2.63214 8.21656 3.75736 7.09134C4.88258 5.96613 6.4087 5.33398 8 5.33398C9.47659 5.33549 10.9008 5.88142 12 6.86732L14 8.66732","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    